import React, { useState, useRef, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  Button,
  TextField,
  IconButton,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Avatar,
  Grid,
  Box,
  AppBar,
  Toolbar,
  Typography,
  Menu,
  MenuItem,
  Modal,
  Select,
  InputLabel,
  FormControl,
  Tabs,
  Tab,
  Card,
  CardContent,
  Divider,
  CardActions,
  Rating,
  Alert,
  Chip,
  Collapse,
  TablePagination,
} from "@mui/material";
import {
  validateName,
  validateEmail,
  validatePhoneNumber,
  validateDropdown,
  validateDropdownForArray,
  validateDOB,
  validateAadhar,
  validateCountry,
  validateState,
  validateCity,
  validateStreet,
  validateLandmark,
  validatePincode,
  validateLicenseNumber,
  validateBikeNumber,
} from "../../utils/textFieldValidations";
import { Delete, UploadFile } from "@mui/icons-material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import StarIcon from "@mui/icons-material/Star";
import { LocalizationProvider, DesktopDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Notifications } from "@mui/icons-material";
import DownloadIcon from "@mui/icons-material/Download";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { styled } from "@mui/system";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AppHeaderBar from "../../components/AppBar/appBar";
import "react-datepicker/dist/react-datepicker.css";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../utils/baseUrl";
import { urls } from "../../urls/urls";
import { useFetch, useDelete, useUpdate } from "../../hooks";
import {
  convertDate,
  convertYearMonthDateToMonthDateYear,
  convertDateToDateMonthYear,
} from "../../utils/DateFormats";
import {
  GoogleMap,
  useLoadScript,
  MarkerF,
  InfoWindowF,
} from "@react-google-maps/api";

const AdminDeliveryManagement = ({ onBackScreenName }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [selectedLicenseFrontFile, setSelectedLicenseFrontFile] =
    useState(null);
  const [selectedLicenseBackFile, setSelectedLicenseBackFile] = useState(null);
  const [selectedProfileFile, setSelectedProfileFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [selectedDeliveryAgentId, setSelectedDeliveryAgentId] = useState(null);
  const [isInfoWindowOpen, setInfoWindowOpen] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [data, setData] = useState("");
  const [errors, setErrors] = useState({});
  const [search, setSearch] = useState("");
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [currentDocument, setCurrentDocument] = useState({
    license: "",
    name: "",
  });
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [open, setOpen] = useState(false);
  const [openPencilModal, setOpenPencilModal] = useState(false);
  const [isEditMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState({ imageUrl: "" });
  const [anchorEl, setAnchorEl] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [moduleStatusData, setModuleStatusData] = useState({});
  const [startTime, setStartTime] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [endTime, setEndTime] = useState("");
  const [dob, setDob] = useState(new Date());
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const [filter, setFilter] = useState("Orders");
  const [orders, setOrders] = useState([]);
  const [id, setId] = useState(14); //For Delivery Mangement id is 14
  const statusURL = BASE_URL_TEST + urls("getStatusById", id);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });

  const [deliveryAgentData, setDeliveryAgentData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    location: "",
    dob: "",
    aadhar: "",
    licenseNumber: "",
    bikeNumber: "",
    licenseFrontImage: "",
    licenseBackImage: "",
    profilePhoto: "",
    country: "",
    state: "",
    city: "",
    street: "",
    landmark: "",
    pincode: "",
    latitude: "",
    longitude: "",
    status: "",
    searchlocation: "",
    id: "",
  });
  const initializeDeliveryAgents = () => {
    setDeliveryAgentData({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      location: "",
      dob: "",
      aadhar: "",
      licenseNumber: "",
      bikeNumber: "",
      licenseFrontImage: "",
      licenseBackImage: "",
      profilePhoto: "",
      country: "",
      state: "",
      city: "",
      street: "",
      landmark: "",
      pincode: "",
      latitude: deliveryAgentData?.latitude,
      longitude: deliveryAgentData?.longitude,
      status: "",
      searchlocation: "",
    });
  };
  const [deliveryAgentViewData, setDeliveryAgentViewData] = useState({
    deliveryAgentId: "",
    name: "",
    email: "",
    phoneNumber: "",
    location: "",
    status: "",
    address: "",
    aadhar: "", // Add this
    dob: "",
  });

  const loginToken = useSelector((state) => state.user.logintoken);
  const [deliveryHistory, setDeliveryHistory] = useState([]);
  const [deliveryOrderStatus, setDeliveryOrderStatus] = useState("ALL");
  const [deliveryPage, setDeliveryPage] = useState(0);
  const [deliveryRowsPerPage, setDeliveryRowsPerPage] = useState(10);
  const useGoogleMaps = () => {
    const { isLoaded, loadError } = useLoadScript({
      googleMapsApiKey: "AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8",
      libraries: ["places"],
    });

    return { isLoaded, loadError };
  };
  const { isLoaded, loadError } = useGoogleMaps();

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setDeliveryAgentData((deliveryAgentData) => ({
          ...deliveryAgentData,
          latitude: latitude,
          longitude: longitude,
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, [latitude, longitude]);

  const createRedIcon = () => {
    if (typeof window !== "undefined" && window.google && window.google.maps) {
      return {
        url: "https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi2.png",
        scaledSize: new window.google.maps.Size(40, 40),
      };
    }
    console.log("Google Maps not loaded yet");
    return null;
  };

  // Function to handle location search using Google Maps Geocoding API
  const handleLocationSearch = async (e) => {
    const searchValue = e.target.value;
    setDeliveryAgentData({
      ...deliveryAgentData,
      searchlocation: searchValue,
    });

    const query = `${deliveryAgentData["country"]}, ${deliveryAgentData["state"]}, ${searchValue}`;
    console.log("query", query);

    if (searchValue) {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
            query,
          )}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
        );

        const data = await response.json();

        if (data.results && data.results.length > 0) {
          const { lat, lng } = data.results[0].geometry.location;
          const newLocation = data.results[0].formatted_address;

          // Update delivery data with latitude, longitude, and location
          setDeliveryAgentData((prevData) => ({
            ...prevData,
            latitude: lat,
            longitude: lng,
          }));

          if (mapRef.current) {
            mapRef.current.setCenter({ lat, lng });
            mapRef.current.setZoom(15);
          }
          if (markerRef.current) {
            markerRef.current.setPosition({ lat, lng });
          }
        } else {
          console.log("No results found.");
        }
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
  };
  //get All DeliveryAgents data and status
  useEffect(() => {
    fetchData();
    fetchDeliveryStatus();
  }, []);

  //get All DeliveryAgents Data
  const {
    data: deliveryAgentsData,
    isLoading: isDeliveryAgentsDataLoading,
    error,
    fetchData,
  } = useFetch(BASE_URL_TEST + urls("getAllDeliveryAgents"), {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: agentOrdersData,
    isLoading: isAgentOrdersLoading,
    error: agentOrdersError,
    fetchData: fetchAgentOrders,
  } = useFetch(BASE_URL_TEST + urls("AgentOrders"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  //get all delivery agents status
  const {
    data: allStatusData,
    isLoading: isStatusLoading,
    error: statusError,
    fetchData: fetchDeliveryStatus,
  } = useFetch(statusURL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: createDeliveryAgentData,
    isLoading: createDeliveryAgentsLoading,
    error: createDeliveryAgentError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createDeliveryAgent"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateDeliveryAgentData,
    isLoading: updateDeliveryAgentLoading,
    error: updateDeliveryAgentError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: deleteDeliveryAgentData,
    isLoading: deleteDeliveryAgentLoading,
    error: deleteDeliveryAgentError,
    deleteData: fetchDeleteData,
  } = useDelete(BASE_URL_TEST, {
    method: "DELETE",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  useEffect(() => {
    if (error) {
    } else if (deliveryAgentsData && deliveryAgentsData["status"] === true) {
      setData(deliveryAgentsData["data"]);
    }
  }, [deliveryAgentsData, error]);

  //getstatus useEffect
  useEffect(() => {
    if (statusError) {
    } else if (allStatusData && allStatusData["status"] === true) {
      setModuleStatusData(allStatusData["data"]);
    }
  }, [allStatusData, statusError]);

  //Create Delivery Agent
  useEffect(() => {
    if (createDeliveryAgentError) {
    } else if (
      createDeliveryAgentData &&
      createDeliveryAgentData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createDeliveryAgentData["message"],
        status: createDeliveryAgentData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      createDeliveryAgentData &&
      createDeliveryAgentData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createDeliveryAgentData["message"],
        status: createDeliveryAgentData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createDeliveryAgentData, createDeliveryAgentError]);

  //Update Delivery Agent
  useEffect(() => {
    if (updateDeliveryAgentError) {
    } else if (
      updateDeliveryAgentData &&
      updateDeliveryAgentData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateDeliveryAgentData["message"],
        status: updateDeliveryAgentData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      updateDeliveryAgentData &&
      updateDeliveryAgentData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateDeliveryAgentData["message"],
        status: updateDeliveryAgentData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateDeliveryAgentData, updateDeliveryAgentError]);

  //Delete Delivery Agent
  useEffect(() => {
    if (deleteDeliveryAgentError) {
    } else if (
      deleteDeliveryAgentData &&
      deleteDeliveryAgentData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: deleteDeliveryAgentData["message"],
        status: deleteDeliveryAgentData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    } else if (
      deleteDeliveryAgentData &&
      deleteDeliveryAgentData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: deleteDeliveryAgentData["message"],
        status: deleteDeliveryAgentData["status"],
      });
      setDeleteModalOpen(true);
      fetchData();
    }
  }, [deleteDeliveryAgentData, deleteDeliveryAgentError]);

  const clearErrors = () => {
    setErrors({});
  };
  // Handle search
  const handleSearch = (event) => {
    setSearch(event.target.value);
  };
  const validateField = (field, value, regex, errorSetter, errorMessage) => {
    const stringValue = value ? String(value).trim() : "";

    if (!stringValue) {
      errorSetter(errorMessage);
      return false;
    }

    if (regex && !regex.test(stringValue)) {
      errorSetter(errorMessage);
      return false;
    }
    errorSetter("");
    return true;
  };

  // Filter data based on search
  const filteredData =
    data && data.length > 0
      ? data
          .sort((a, b) => b.agent_id - a.agent_id) // Sort by ID in descending order, latest ID first
          .filter(
            (item) =>
              (item.agent_id &&
                item.agent_id
                  .toString()
                  .toLowerCase()
                  .includes(search.toLowerCase())) ||
              (item.first_name &&
                item.first_name.toLowerCase().includes(search.toLowerCase())) ||
              (item.location &&
                item.location.toLowerCase().includes(search.toLowerCase())) ||
              (item.email &&
                item.email.toLowerCase().includes(search.toLowerCase())) ||
              (item.phone_number &&
                item.phone_number.toString().includes(search.toLowerCase())) ||
              (item.status &&
                item.status.toLowerCase().includes(search.toLowerCase())),
          )
      : data;

  const handleAdd = () => {
    setEditMode(false);
    initializeDeliveryAgents();
    clearErrors();
    setOpen(true);
  };
  const LocationPicker = ({ setLatitude, setLongitude, setLocation }) => {
    const handleMapClick = (e) => {
      const lat = e.latLng.lat();
      const lng = e.latLng.lng();
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          const address = results[0].formatted_address;
          setLatitude(lat);
          setLongitude(lng);
        }
      });
    };
  };

  const [feedbacks, setFeedbacks] = useState([
    {
      id: 1,
      date: "2024-11-28",
      brand: "Brand name",
      color: "color",
      message: "Great service! Very satisfied with my purchase.",
      imageUrl: "path/to/image1.jpg",
      response:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      approved: false,
      rating: 4,
    },
    {
      id: 2,
      date: "2023-05-10",
      brand: "Brand name",
      color: "color",
      message:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      imageUrl: "path/to/image2.jpg",
      response:
        "Thank you for your kind words, Alice! We're glad you're satisfied.",
      approved: true,
      rating: 5,
    },
  ]);
  const [expandedRow, setExpandedRow] = useState(null);

  const handleRowClick = (index) => {
    setExpandedRow(expandedRow === index ? null : index);
  };

  const [sortOption, setSortOption] = useState("");

  const handleApprove = (id) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, approved: true } : feedback,
      ),
    );
  };

  const handleDelete1 = (id) => {
    setFeedbacks(feedbacks.filter((feedback) => feedback.id !== id));
  };

  const handleSort = (option) => {
    setSortOption(option);
    let filteredFeedbacks;
    const currentDate = new Date();

    if (option === "thisWeek") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        const weekAgo = new Date();
        weekAgo.setDate(currentDate.getDate() - 7);
        return feedbackDate >= weekAgo && feedbackDate <= currentDate;
      });
    } else if (option === "thisMonth") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        return (
          feedbackDate.getMonth() === currentDate.getMonth() &&
          feedbackDate.getFullYear() === currentDate.getFullYear()
        );
      });
    } else if (option === "thisYear") {
      filteredFeedbacks = feedbacks.filter((feedback) => {
        const feedbackDate = new Date(feedback.date);
        return feedbackDate.getFullYear() === currentDate.getFullYear();
      });
    } else {
      filteredFeedbacks = feedbacks;
    }

    setFeedbacks(filteredFeedbacks);
  };

  const handleResponseChange = (id, value) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, response: value } : feedback,
      ),
    );
  };

  const handleRatingChange = (id, newRating) => {
    setFeedbacks(
      feedbacks.map((feedback) =>
        feedback.id === id ? { ...feedback, rating: newRating } : feedback,
      ),
    );
  };

  const redeemHistory = [
    { orderId: "ORD123456", points: 100, date: "19 Jan 2024" },
    { orderId: "ORD789101", points: 200, date: "20 Jan 2024" },
  ];

  const fetchOrders = (filter) => {
    const mockData = {
      Orders: [
        {
          id: "order1",
          name: "Product Name",
          price: 700,
          payment: "online payment",
          date: "19 Jan 2024",
        },
        {
          id: "order2",
          name: "Product Name",
          price: 800,
          payment: "COD",
          date: "19 Jan 2024",
        },
      ],
      Shipped: [
        {
          id: "order3",
          name: "Product Name",
          price: 700,
          payment: "online payment",
          date: "19 Jan 2024",
        },
        {
          id: "order4",
          name: "Product Name",
          price: 800,
          payment: "COD",
          date: "19 Jan 2024",
        },
      ],
      Canceled: [],
      "Returned/Refund": [],
    };
    setOrders(mockData[filter] || []);
  };

  useEffect(() => {
    fetchOrders(filter);
  }, [filter]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const TabPanel = ({ children, value, index }) => {
    return (
      <div hidden={value !== index}>
        {value === index && <Box p={3}>{children}</Box>}
      </div>
    );
  };

  const handleEdit = async (deliveryAgent) => {
    setEditMode(true);
    setOpen(true);
    setDeliveryAgentData({
      ...deliveryAgentData,
      firstName: deliveryAgent["first_name"],
      lastName: deliveryAgent["last_name"],
      location: deliveryAgent["location"],
      email: deliveryAgent["email"],
      phoneNumber: deliveryAgent["phone_number"],
      dob: deliveryAgent["dob"]
        ? convertYearMonthDateToMonthDateYear(deliveryAgent["dob"])
        : null,
      aadhar: deliveryAgent["aadhar"],
      licenseNumber: deliveryAgent["license_number"],
      bikeNumber: deliveryAgent["bike_number"],
      licenseFrontImage: deliveryAgent["driving_license_front"],
      licenseBackImage: deliveryAgent["driving_license_back"],
      profilePhoto: deliveryAgent["profile"],
      country: deliveryAgent["country"],
      state: deliveryAgent["state"],
      city: deliveryAgent["city"],
      street: deliveryAgent["street"],
      landmark: deliveryAgent["landmark"],
      pincode: deliveryAgent["pincode"],
      latitude: deliveryAgent["latitude"],
      longitude: deliveryAgent["longitude"],
      status: deliveryAgent["status"],
      id: deliveryAgent["agent_id"],
    });
    if (deliveryAgent.latitude && deliveryAgent.longitude) {
      const latitude = parseFloat(deliveryAgent.latitude);
      const longitude = parseFloat(deliveryAgent.longitude);
      try {
        const reverseGeocodeResponse = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${deliveryAgent.latitude},${deliveryAgent.longitude}&key=AIzaSyA6CszWLFAJsbbDNtAtoXEWgWzqhU3pHB8`,
        );
        const reverseGeocodeData = await reverseGeocodeResponse.json();

        if (
          reverseGeocodeData.results &&
          reverseGeocodeData.results.length > 0
        ) {
          const address = reverseGeocodeData.results[0].formatted_address;

          // Update Delivery agent data with the formatted address (location)
          setDeliveryAgentData((prevData) => ({
            ...prevData,
            searchlocation: address,
          }));
        }
        setTimeout(() => {
          if (mapRef.current) {
            const map = mapRef.current;
            const center = { lat: latitude, lng: longitude };
            map.panTo(center);
            map.setZoom(15);
          }

          if (markerRef.current) {
            markerRef.current.setPosition({ lat: latitude, lng: longitude });
          }
        }, 100);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    }
    setAnchorEl(null);
  };

  const handleDelete = (deliveryAgentId) => {
    const deleteUrl = urls("deleteDeliveryAgent", deliveryAgentId);
    fetchDeleteData(deleteUrl);
  };

  const handleSubmit = () => {
    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,20}$/;
    let validationErrors = {};

    if (!validateName(deliveryAgentData.firstName)) {
      validationErrors.firstName =
        "Name is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateEmail(deliveryAgentData.email)) {
      validationErrors.email = "Please enter a valid email address.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePhoneNumber(deliveryAgentData.phoneNumber)) {
      validationErrors.phoneNumber = "Please enter a 10 digit phone number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCity(deliveryAgentData.location)) {
      validationErrors.location =
        "Location is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateDOB(deliveryAgentData.dob)) {
      validationErrors.dob = "Date of birth is required.";
      setErrors(validationErrors);
      return;
    }
    if (!validateAadhar(deliveryAgentData.aadhar)) {
      validationErrors.aadhar = "Aadhar number must be a 12-digit number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateLicenseNumber(deliveryAgentData.licenseNumber)) {
      validationErrors.licenseNumber = "Please enter valid License Number.";
      setErrors(validationErrors);
      return;
    }
    if (!validateBikeNumber(deliveryAgentData.bikeNumber)) {
      validationErrors.bikeNumber = "Please enter valid Bike Number.";
      setErrors(validationErrors);
      return;
    }
    if (!deliveryAgentData.licenseFrontImage) {
      validationErrors.licenseFrontImageError =
        "License Front Image is required.";
      setErrors(validationErrors);
      return;
    }
    if (!deliveryAgentData.licenseBackImage) {
      validationErrors.licenseBackImageError =
        "License Back Image is required.";
      setErrors(validationErrors);
      return;
    }
    if (!deliveryAgentData.profilePhoto) {
      validationErrors.profilePhotoError = "Profile photo is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validateCountry(deliveryAgentData.country)) {
      validationErrors.country =
        "Country is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateState(deliveryAgentData.state)) {
      validationErrors.state =
        "State is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }

    if (!validateStreet(deliveryAgentData.street)) {
      validationErrors.street =
        "Street is required and can contain letters, numbers, spaces, commas, periods, hyphens, and hashes..";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(deliveryAgentData.landmark)) {
      validationErrors.landmark = "Landmark is required.";
      setErrors(validationErrors);
      return;
    }

    if (!validatePincode(deliveryAgentData.pincode)) {
      validationErrors.pincode = "Pincode should be a 6-digit number.";
      setErrors(validationErrors);
      return;
    }

    if (!validateLandmark(deliveryAgentData.searchlocation)) {
      validationErrors.searchlocation = "Location is required.";
      setErrors(validationErrors);
      return;
    }
    if (!validateDropdownForArray(deliveryAgentData.status)) {
      validationErrors.statusDropdown = "Please select status.";
      setErrors(validationErrors);
      return;
    }
    if (!isEditMode) {
      if (
        !validateField(
          "password",
          deliveryAgentData["password"],
          passwordRegex,
          setPasswordError,
          "Password must be between 8-20 characters, include uppercase, lowercase, a number, and a special character.",
        )
      )
        return false;

      if (!deliveryAgentData.confirmPassword) {
        setConfirmPasswordError("Confirm password is required.");
        return false;
      }
      if (
        deliveryAgentData["password"] !== deliveryAgentData["confirmPassword"]
      ) {
        setConfirmPasswordError("Passwords do not match.");
        return false;
      }
    }

    clearErrors();
    setPasswordError("");
    setConfirmPasswordError("");

    const formdata = new FormData();
    formdata.append("first_name", deliveryAgentData["firstName"]);
    formdata.append("last_name", deliveryAgentData["lastName"]);
    formdata.append("location", deliveryAgentData["location"]);
    formdata.append("email", deliveryAgentData["email"]);
    formdata.append("phone_number", deliveryAgentData["phoneNumber"]);
    formdata.append("status", deliveryAgentData["status"]);
    formdata.append(
      "dob",
      deliveryAgentData.dob
        ? convertDateToDateMonthYear(deliveryAgentData.dob)
        : null,
    );
    formdata.append("license_number", deliveryAgentData["licenseNumber"]);
    formdata.append("bike_number", deliveryAgentData["bikeNumber"]);
    formdata.append("aadhar", deliveryAgentData["aadhar"]);
    formdata.append("country", deliveryAgentData["country"]);
    formdata.append("state", deliveryAgentData["state"]);
    formdata.append("city", deliveryAgentData["location"]);
    formdata.append("street", deliveryAgentData["street"]);
    formdata.append("landmark", deliveryAgentData["landmark"]);
    formdata.append("pincode", deliveryAgentData["pincode"]);
    formdata.append("latitude", deliveryAgentData["latitude"]);
    formdata.append("longitude", deliveryAgentData["longitude"]);
    formdata.append(
      "license_front",
      selectedLicenseFrontFile
        ? selectedLicenseFrontFile
        : deliveryAgentData["driving_license_front"],
    );
    formdata.append(
      "license_back",
      selectedLicenseBackFile
        ? selectedLicenseBackFile
        : deliveryAgentData["driving_license_back"],
    );
    formdata.append(
      "profile",
      selectedProfileFile ? selectedProfileFile : deliveryAgentData["profile"],
    );
    formdata.append("password", deliveryAgentData["confirmPassword"]);
    if (isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contentsupdate:", `${key}: ${value}`);
      }
      const updateUrl = urls("updateDeliveryAgent", deliveryAgentData["id"]);
      fetchUpdateData(updateUrl, formdata);
    } else if (!isEditMode) {
      for (let [key, value] of formdata.entries()) {
        console.log("Form Data Contents:", `${key}: ${value}`);
      }
      fetchCreateData(formdata);
    }
  };

  const handleMenuOpen = (event, deliveryAgentId) => {
    setAnchorEl(event.currentTarget);
    setSelectedDeliveryAgentId(deliveryAgentId);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePencilModalOpen = () => {
    setOpenPencilModal(true);
  };

  //For View the Delivery Agent data
  const handleView = (event, deliveryAgent) => {
    setSelectedDeliveryAgentId(deliveryAgent.agent_id);
    setOpenViewModal(true);
    setDeliveryAgentViewData({
      ...deliveryAgentViewData,
      deliveryAgentId: deliveryAgent["agent_id"],
      name: deliveryAgent["first_name"],
      email: deliveryAgent["email"],
      phoneNumber: deliveryAgent["phone_number"],
      location: deliveryAgent["location"],
      status: deliveryAgent["status"],
      address: deliveryAgent["location"],
      aadhar: deliveryAgent["aadhar"], // Add this
      dob: deliveryAgent["dob"] // Add this
        ? convertYearMonthDateToMonthDateYear(deliveryAgent["dob"])
        : "",
    });
    fetchAgentOrders({
      agent_id: String(deliveryAgent.agent_id),
      order_status: "ALL",
    });
  };
  useEffect(() => {
    if (agentOrdersData && agentOrdersData.status === true) {
      setDeliveryHistory(agentOrdersData.data || []);
    }
  }, [agentOrdersData]);
  useEffect(() => {
    if (selectedDeliveryAgentId && openViewModal) {
      fetchAgentOrders({
        agent_id: String(selectedDeliveryAgentId),
        order_status: deliveryOrderStatus,
      });
      setDeliveryPage(0);
    }
  }, [deliveryOrderStatus]);
  const handleViewClose = () => {
    setOpenViewModal(false);
  };
  const handleClear = () => {
    setEditData({ ...editData, Category: [] }); // Clear the selected values
  };

  const handleImageUpload = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const imageUrl = URL.createObjectURL(file); // Creating a temporary URL for the image
      setEditData({ ...editData, imageUrl });
    }
  };

  const handleImageDelete = () => {
    setEditData({ ...editData, imageUrl: "" }); // Removing the image URL
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const allowedTypes = [
  //       "application/pdf",
  //       "application/vnd.ms-excel",
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       "application/msword",
  //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     ];
  //     if (!allowedTypes.includes(file.type)) {
  //       setError("Only PDF, Excel, and Word documents are allowed");
  //       setCurrentDocument({ license: "", name: "" });
  //       e.target.value = ""; // Reset file input
  //       return;
  //     }

  //     if (file.size > 5 * 1024 * 1024) {
  //       setError("File size should not exceed 5MB");
  //       setCurrentDocument({ license: "", name: "" });
  //       e.target.value = ""; // Reset file input
  //       return;
  //     }

  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setCurrentDocument({ license: reader.result, name: file.name });
  //       setError(null);
  //       e.target.value = ""; // Reset file input
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleDocDelete = () => {
    setCurrentDocument({ license: "", name: "" });
    //setError(null);
  };
  const handleScreeName = (sname) => {
    console.log("sname", sname);
    onBackScreenName(sname);
  };
  const handleProfileImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      setDeliveryAgentData({
        ...deliveryAgentData,
        profilePhoto: URL.createObjectURL(file),
      });
      setSelectedProfileFile(file);
    }
  };
  const handleLicenseFrontImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      setDeliveryAgentData({
        ...deliveryAgentData,
        licenseFrontImage: URL.createObjectURL(file),
      });
      setSelectedLicenseFrontFile(file);
    }
  };
  const handleLicenseBackImage = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      setDeliveryAgentData({
        ...deliveryAgentData,
        licenseBackImage: URL.createObjectURL(file),
      });
      setSelectedLicenseBackFile(file);
    }
  };

  //close button
  const handleClose = () => {
    setModalOpen(false);
    setDeleteModalOpen(false);
    clearErrors();
    setPasswordError("");
    setConfirmPasswordError("");
    if (createDeliveryAgentData && createDeliveryAgentData["status"] === true) {
      initializeDeliveryAgents();
      setDeliveryAgentData({
        latitude: "",
        longitude: "",
      });
      setOpen(false);
    }
    if (isEditMode) {
      if (
        updateDeliveryAgentData &&
        updateDeliveryAgentData["status"] === true
      ) {
        initializeDeliveryAgents();
        setDeliveryAgentData({
          latitude: "",
          longitude: "",
        });
        setOpen(false);
      }
    }
    setSnackbarState({
      message: "",
      status: "",
    });
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Password
  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setDeliveryAgentData({ ...deliveryAgentData, password: newPassword });
  };
  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setDeliveryAgentData({
      ...deliveryAgentData,
      confirmPassword: newConfirmPassword,
    });
  };
  const handlePasswordVisibilityToggle = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handleConfirmPasswordVisibilityToggle = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        p: 2,
        bgcolor: "#EEF2FF",
      }}
    >
      {/* Header */}
      <AppHeaderBar
        title={"Delivery Management"}
        onBackScreenName={handleScreeName}
      />
      <Box sx={{ p: 3, backgroundColor: "#F9FAFC" }}>
        <Grid
          container
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          style={{ marginBottom: "30px" }}
        >
          <Grid item>
            <TextField
              label="Search"
              variant="outlined"
              size="small"
              value={search}
              onChange={handleSearch}
            />
          </Grid>
          <Grid item>
            <Button variant="outlined" startIcon={<DownloadIcon />}>
              Download Excel
            </Button>
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              style={{ marginLeft: "10px" }}
              onClick={handleAdd}
            >
              Add Agent
            </Button>
          </Grid>
        </Grid>

        <TableContainer component={Paper} sx={{ borderRadius: "20px" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
              <TableRow>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  AgentId
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Name
                </TableCell>

                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Location
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Email
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Phone
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Status
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  Actions
                </TableCell>
                <TableCell
                  sx={{
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    overflow: "hidden",
                  }}
                >
                  View
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    <Typography>No records found</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filteredData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((deliveryAgent) => {
                    return (
                      <TableRow key={deliveryAgent.agent_id}>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {deliveryAgent.agent_id}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <Box
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {deliveryAgent.first_name}
                          </Box>
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {deliveryAgent.location}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {deliveryAgent.email}
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          {deliveryAgent.phone_number}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            color:
                              deliveryAgent.status === "Pause"
                                ? "orange"
                                : deliveryAgent.status === "Active"
                                  ? "green"
                                  : deliveryAgent.status === "In Active"
                                    ? "red"
                                    : "black", // Default color for other statuses
                            fontWeight: "bold", // Optional: Makes the text bold
                          }}
                        >
                          {deliveryAgent.status}
                        </TableCell>

                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            onClick={(e) =>
                              handleMenuOpen(e, deliveryAgent.agent_id)
                            }
                          >
                            <MoreVertIcon />
                          </IconButton>
                          <Menu
                            anchorEl={anchorEl}
                            open={
                              Boolean(anchorEl) &&
                              selectedDeliveryAgentId === deliveryAgent.agent_id
                            }
                            onClose={handleMenuClose}
                          >
                            <MenuItem onClick={() => handleEdit(deliveryAgent)}>
                              <EditIcon /> Edit
                            </MenuItem>
                            <MenuItem
                              onClick={() => handleDelete(deliveryAgent.id)}
                            >
                              <DeleteIcon /> Delete
                            </MenuItem>
                          </Menu>
                        </TableCell>
                        <TableCell
                          sx={{
                            whiteSpace: "nowrap",
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                          }}
                        >
                          <IconButton
                            color="primary"
                            onClick={(e) => handleView(e, deliveryAgent)}
                          >
                            <VisibilityIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 50, 100, 150]}
          component="div"
          count={data && data.length ? data.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
        <Dialog
          open={isDeleteModalOpen}
          onClose={() => setDeleteModalOpen(false)}
        >
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Modal for Add/Edit */}
        <Modal
          open={open}
          onClose={() => setOpen(false)}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              width: "90vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll", // Enable vertical scrolling
              borderRadius: 2, // Rounded corners
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Webkit browsers
              },
              "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer and Edge
              "scrollbar-width": "none", // Hide scrollbar for Firefox
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
                {isEditMode ? "Edit Agent" : "Add Agent"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={() => setOpen(false)}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                autoFocus
                margin="dense"
                label="Name"
                type="text"
                fullWidth
                value={deliveryAgentData?.firstName || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    firstName: e.target.value,
                  })
                }
                error={!!errors.firstName}
                helperText={
                  errors.firstName && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.firstName}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Last Name"
                type="text"
                fullWidth
                value={deliveryAgentData?.lastName || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    lastName: e.target.value,
                  })
                }
              />

              <TextField
                margin="dense"
                label="Email"
                type="email"
                fullWidth
                value={deliveryAgentData?.email || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    email: e.target.value,
                  })
                }
                error={!!errors.email}
                helperText={
                  errors.email && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.email}
                    </Typography>
                  )
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <TextField
                  margin="dense"
                  label="Phone"
                  type="tel"
                  fullWidth
                  value={deliveryAgentData?.phoneNumber || ""}
                  onChange={(e) =>
                    setDeliveryAgentData({
                      ...deliveryAgentData,
                      phoneNumber: e.target.value,
                    })
                  }
                  error={!!errors.phoneNumber}
                  helperText={
                    errors.phoneNumber && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.phoneNumber}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <TextField
                  margin="dense"
                  label="Location"
                  type="text"
                  fullWidth
                  value={deliveryAgentData?.location || ""}
                  onChange={(e) =>
                    setDeliveryAgentData({
                      ...deliveryAgentData,
                      location: e.target.value,
                    })
                  }
                  error={!!errors.location}
                  helperText={
                    errors.location && (
                      <Typography
                        sx={{
                          textAlign: "left",
                          marginTop: 1,
                          color: "red",
                          fontSize: 12,
                        }}
                      >
                        {errors.location}
                      </Typography>
                    )
                  }
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DesktopDatePicker
                    label="Date of Birth"
                    value={
                      deliveryAgentData.dob
                        ? new Date(deliveryAgentData.dob)
                        : null
                    }
                    maxDate={new Date()}
                    onChange={(newValue) => {
                      setDeliveryAgentData({
                        ...deliveryAgentData,
                        dob: newValue,
                      });

                      // Clear error if the date is valid
                      if (newValue) {
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          dob: null,
                        }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField {...params} fullWidth sx={{ mb: 4 }} />
                    )}
                  />
                  {errors.dob && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.dob}
                    </Typography>
                  )}
                </LocalizationProvider>
              </Box>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Aadhar Number"
                type="tel"
                fullWidth
                value={deliveryAgentData?.aadhar || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    aadhar: e.target.value,
                  })
                }
                error={!!errors.aadhar}
                helperText={
                  errors.aadhar && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.aadhar}
                    </Typography>
                  )
                }
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <TextField
                autoFocus
                margin="dense"
                label="License Number"
                type="text"
                fullWidth
                value={deliveryAgentData?.licenseNumber || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    licenseNumber: e.target.value,
                  })
                }
                placeholder="Example: ABC12345"
                error={!!errors.licenseNumber}
                helperText={
                  errors.licenseNumber && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.licenseNumber}
                    </Typography>
                  )
                }
              />
              <TextField
                autoFocus
                margin="dense"
                label="Bike Number"
                type="text"
                fullWidth
                value={deliveryAgentData?.bikeNumber || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    bikeNumber: e.target.value,
                  })
                }
                placeholder="Example: Ap12AB1234"
                error={!!errors.bikeNumber}
                helperText={
                  errors.bikeNumber && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.bikeNumber}
                    </Typography>
                  )
                }
              />
            </Box>

            {/* <Box
              sx={{
                p: 1,
                border: "1px solid #ccc",
                borderRadius: 2,
                maxWidth: 400,
                // margin: "0 auto",
                textAlign: "center",
              }}
            >
              <Typography variant="h6" gutterBottom>
                Upload Driving License
              </Typography>
              <Button variant="outlined" component="label" sx={{ mb: 2 }}>
                Upload Document
                <input
                  type="file"
                  hidden
                  accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  //onChange={handleFileChange}
                />
              </Button>
              {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              )}
              {currentDocument.license && (
                <Box sx={{ mt: 0 }}>
                  <Typography variant="body2">
                    Document Uploaded Successfully: {currentDocument.name}
                  </Typography>
                  {currentDocument.license &&
                    currentDocument.name.endsWith(".pdf") && (
                      <Box sx={{ mt: 2, border: "1px solid #ddd" }}>
                        <iframe
                          src={currentDocument.license}
                          title="Document Preview"
                          style={{
                            width: "100%",
                            height: "300px",
                            border: "none",
                          }}
                        ></iframe>
                      </Box>
                    )}
                  {currentDocument.license &&
                    !currentDocument.name.endsWith(".pdf") && (
                      <Box sx={{ mt: 2 }}>
                        <Typography variant="body2">
                          <a
                            href={currentDocument.license}
                            download={currentDocument.name}
                            style={{ textDecoration: "none", color: "#1976d2" }}
                          >
                            Click here to download {currentDocument.name}
                          </a>
                        </Typography>
                      </Box>
                    )}
                  <IconButton
                    color="error"
                    onClick={handleDocDelete}
                    sx={{ mt: 1 }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              )}
            </Box> */}
            <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
              {/* Upload License Front Image Section */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                  Upload License Front Image
                </Typography>
                <Avatar
                  alt="Image"
                  src={
                    deliveryAgentData?.licenseFrontImage ||
                    "/default-profile.png"
                  }
                  sx={{
                    width: 150,
                    height: 150,
                    border: "2px solid #ddd",
                    mb: 1,
                    borderRadius: 0,
                  }}
                />
                <Typography variant="body2" color="textSecondary" marginTop={1}>
                  (Image size: 40kb) (Only Jpg, png images allowed)
                </Typography>
                {errors.licenseFrontImageError && (
                  <helperText>
                    <Typography
                      sx={{
                        mt: 2,
                        color: "red",
                        fontWeight: "bold",
                        fontSize: 12,
                      }}
                    >
                      {errors.licenseFrontImageError}
                    </Typography>
                  </helperText>
                )}
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<UploadFile />}
                      sx={{
                        mr: 2,
                        bgcolor: "#3f51b5",
                        "&:hover": { bgcolor: "#303f9f" },
                      }}
                    >
                      Upload Image
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={handleLicenseFrontImage}
                      />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => {
                        setDeliveryAgentData((prevData) => ({
                          ...prevData,
                          licenseFrontImage: "",
                        }));
                      }}
                      sx={{
                        color: "#f44336",
                        borderColor: "#f44336",
                        "&:hover": { bgcolor: "#ffe6e6" },
                      }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Grid>

              {/* Upload License Back Image Section */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                  Upload License Back Image
                </Typography>
                <Avatar
                  alt="Image"
                  src={
                    deliveryAgentData?.licenseBackImage ||
                    "/default-profile.png"
                  }
                  sx={{
                    width: 150,
                    height: 150,
                    border: "2px solid #ddd",
                    mb: 1,
                    borderRadius: 0,
                  }}
                />
                <Typography variant="body2" color="textSecondary" marginTop={1}>
                  (Image size: 40kb) (Only Jpg, png images allowed)
                </Typography>
                {errors.licenseBackImageError && (
                  <helperText>
                    <Typography
                      sx={{
                        mt: 2,
                        color: "red",
                        fontWeight: "bold",
                        fontSize: 12,
                      }}
                    >
                      {errors.licenseBackImageError}
                    </Typography>
                  </helperText>
                )}
                <Grid container spacing={2} sx={{ mt: 2 }}>
                  <Grid item>
                    <Button
                      variant="contained"
                      component="label"
                      startIcon={<UploadFile />}
                      sx={{
                        mr: 2,
                        bgcolor: "#3f51b5",
                        "&:hover": { bgcolor: "#303f9f" },
                      }}
                    >
                      Upload Image
                      <input
                        hidden
                        accept="image/*"
                        type="file"
                        onChange={handleLicenseBackImage}
                      />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      startIcon={<Delete />}
                      onClick={() => {
                        setDeliveryAgentData((prevData) => ({
                          ...prevData,
                          licenseBackImage: "",
                        }));
                      }}
                      sx={{
                        color: "#f44336",
                        borderColor: "#f44336",
                        "&:hover": { bgcolor: "#ffe6e6" },
                      }}
                    >
                      Delete
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={2} sx={{ mb: 4 }} alignItems="center">
              <Grid item xs={12} sm={3}>
                <Typography variant="body1" sx={{ mb: 1, fontWeight: "bold" }}>
                  Profile Photo
                </Typography>
                <Avatar
                  alt="Profile"
                  src={
                    deliveryAgentData?.profilePhoto || "/default-profile.png"
                  }
                  sx={{
                    width: 100,
                    height: 100,
                    border: "2px solid #ddd",
                    mb: 1,
                  }}
                />
                <Typography variant="body2" color="textSecondary" marginTop={1}>
                  Image should be in 300 X 300 pixels.(size:40kb) (Only Jpg,png
                  images allowed)
                </Typography>
              </Grid>
              <Grid item xs={12} sm={9}>
                <Button
                  variant="contained"
                  component="label"
                  startIcon={<UploadFile />}
                  sx={{
                    mr: 2,
                    bgcolor: "#3f51b5",
                    "&:hover": { bgcolor: "#303f9f" },
                  }}
                >
                  Upload Image
                  <input
                    hidden
                    accept="image/*"
                    type="file"
                    onChange={handleProfileImage}
                  />
                </Button>

                <Button
                  variant="outlined"
                  startIcon={<Delete />}
                  onClick={() => {
                    setDeliveryAgentData((prevData) => ({
                      ...prevData,
                      profilePhoto: "",
                    }));
                  }}
                  sx={{
                    color: "#f44336",
                    borderColor: "#f44336",
                    "&:hover": { bgcolor: "#ffe6e6" },
                  }}
                >
                  Delete
                </Button>
                {errors.profilePhotoError && (
                  <helperText>
                    <Typography
                      sx={{
                        mt: 2,
                        color: "red",
                        fontWeight: "bold",
                        fontSize: 12,
                      }}
                    >
                      {errors.profilePhotoError}
                    </Typography>
                  </helperText>
                )}
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                gap: "20px",
                marginBottom: "20px",
                mt: 2,
                justifyContent: "space-between", // Distribute space evenly between the items
              }}
            >
              <Box sx={{ flex: 2, mt: 2 }}></Box>
            </Box>
            <Box sx={{ mt: 2 }}>
              <Typography variant="h6">Address</Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Country"
                type="tel"
                fullWidth
                value={deliveryAgentData?.country || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    country: e.target.value,
                  })
                }
                error={!!errors.country}
                helperText={
                  errors.country && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.country}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="State"
                type="tel"
                fullWidth
                value={deliveryAgentData?.state || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    state: e.target.value,
                  })
                }
                error={!!errors.state}
                helperText={
                  errors.state && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.state}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="City"
                type="tel"
                fullWidth
                value={deliveryAgentData?.location || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    city: e.target.value,
                  })
                }
              />
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <TextField
                margin="dense"
                label="Street"
                type="tel"
                fullWidth
                value={deliveryAgentData?.street || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    street: e.target.value,
                  })
                }
                error={!!errors.street}
                helperText={
                  errors.street && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.street}
                    </Typography>
                  )
                }
              />
              <TextField
                margin="dense"
                label="Land mark"
                type="tel"
                fullWidth
                value={deliveryAgentData?.landmark || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    landmark: e.target.value,
                  })
                }
                error={!!errors.landmark}
                helperText={
                  errors.landmark && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.landmark}
                    </Typography>
                  )
                }
              />

              <TextField
                margin="dense"
                label="Pin code"
                type="tel"
                fullWidth
                value={deliveryAgentData?.pincode || ""}
                onChange={(e) =>
                  setDeliveryAgentData({
                    ...deliveryAgentData,
                    pincode: e.target.value,
                  })
                }
                error={!!errors.pincode}
                helperText={
                  errors.pincode && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.pincode}
                    </Typography>
                  )
                }
              />
            </Box>

            <Box sx={{}}>
              <Typography variant="h6">Select Location</Typography>

              {/* Search Box */}
              <TextField
                fullWidth
                margin="dense"
                label="Search Location"
                variant="outlined"
                sx={{ mt: 2 }}
                value={deliveryAgentData?.searchlocation}
                onChange={handleLocationSearch}
                error={!!errors.searchlocation}
                helperText={
                  errors.searchlocation && (
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.searchlocation}
                    </Typography>
                  )
                }
              />

              {/* Map Container */}
              <Box sx={{ padding: 3 }}>
                <GoogleMap
                  ref={mapRef}
                  onLoad={(map) => {
                    mapRef.current = map;
                    if (
                      deliveryAgentData.latitude &&
                      deliveryAgentData.longitude
                    ) {
                      map.panTo({
                        lat: parseFloat(deliveryAgentData.latitude),
                        lng: parseFloat(deliveryAgentData.longitude),
                      });
                      map.setZoom(15);
                    }
                  }}
                  center={{
                    lat: parseFloat(deliveryAgentData.latitude) || 0,
                    lng: parseFloat(deliveryAgentData.longitude) || 0,
                  }}
                  zoom={13}
                  mapContainerStyle={{
                    height: "400px",
                    width: "100%",
                    marginTop: "20px",
                  }}
                  options={{
                    streetViewControl: false,
                    mapTypeControl: false,
                  }}
                  // ✅ Click anywhere on map to move marker
                  onClick={(e) => {
                    const lat = e.latLng.lat();
                    const lng = e.latLng.lng();
                    setDeliveryAgentData((prevData) => ({
                      ...prevData,
                      latitude: lat,
                      longitude: lng,
                    }));
                  }}
                >
                  {deliveryAgentData.latitude &&
                    deliveryAgentData.longitude && (
                      <MarkerF
                        ref={markerRef}
                        position={{
                          lat: parseFloat(deliveryAgentData.latitude),
                          lng: parseFloat(deliveryAgentData.longitude),
                        }}
                        icon={createRedIcon()}
                        draggable={true} // ✅ Allow dragging
                        // ✅ Update position when dragged
                        onDragEnd={(e) => {
                          const lat = e.latLng.lat();
                          const lng = e.latLng.lng();
                          setDeliveryAgentData((prevData) => ({
                            ...prevData,
                            latitude: lat,
                            longitude: lng,
                          }));
                        }}
                        onClick={() => setInfoWindowOpen(true)}
                      >
                        {isInfoWindowOpen && (
                          <InfoWindowF
                            position={{
                              lat: parseFloat(deliveryAgentData.latitude),
                              lng: parseFloat(deliveryAgentData.longitude),
                            }}
                            onCloseClick={() => setInfoWindowOpen(false)}
                          >
                            <div>
                              <p>
                                Latitude: {deliveryAgentData.latitude},
                                Longitude: {deliveryAgentData.longitude}
                              </p>
                            </div>
                          </InfoWindowF>
                        )}
                      </MarkerF>
                    )}
                </GoogleMap>
              </Box>

              {/* Latitude and Longitude Text Fields */}
              <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                <TextField
                  margin="dense"
                  label="Latitude"
                  type="text"
                  fullWidth
                  value={deliveryAgentData?.latitude || ""}
                  InputProps={{
                    readOnly: true, // Make the field read-only as it's filled by map
                  }}
                />
                <TextField
                  margin="dense"
                  label="Longitude"
                  type="text"
                  fullWidth
                  value={deliveryAgentData?.longitude || ""}
                  InputProps={{
                    readOnly: true, // Make the field read-only as it's filled by map
                  }}
                />
              </Box>
            </Box>
            <Box>
              {/* <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  id="status-select"
                  value={deliveryAgentData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setDeliveryAgentData({
                      ...deliveryAgentData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {moduleStatusData &&
                  typeof moduleStatusData.options === "string" ? (
                    moduleStatusData.options.split(",").map((option, index) => (
                      <MenuItem key={index} value={option.trim()}>
                        {option.trim()}
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem disabled>No status data available</MenuItem>
                  )}
                </Select>
                {errors.statusDropdown && (
                  <helperText>
                    <Typography
                      sx={{
                        textAlign: "left",
                        marginTop: 1,
                        color: "red",
                        fontSize: 12,
                      }}
                    >
                      {errors.statusDropdown}
                    </Typography>
                  </helperText>
                )}
              </FormControl> */}
              <FormControl fullWidth margin="dense">
                <InputLabel id="status-label">Status</InputLabel>

                <Select
                  labelId="status-label"
                  id="status-select"
                  value={deliveryAgentData?.status || ""}
                  error={!!errors.statusDropdown}
                  onChange={(e) =>
                    setDeliveryAgentData({
                      ...deliveryAgentData,
                      status: e.target.value,
                    })
                  }
                  label="Status"
                >
                  {[
                    "active",
                    "inactive ",
                    "pending",
                    "on-hold",
                    "stopped",
                    "rejected",
                  ].map((status, index) => (
                    <MenuItem key={index} value={status}>
                      {status}
                    </MenuItem>
                  ))}
                </Select>

                {errors.statusDropdown && (
                  <Typography
                    sx={{
                      textAlign: "left",
                      marginTop: 1,
                      color: "red",
                      fontSize: 12,
                    }}
                  >
                    {errors.statusDropdown}
                  </Typography>
                )}
              </FormControl>
            </Box>
            <Box sx={{ display: "flex", mt: 1, gap: 2 }}>
              <TextField
                label="Password"
                type={isPasswordVisible ? "text" : "password"}
                value={deliveryAgentData?.password}
                fullWidth
                onChange={handlePasswordChange}
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={handlePasswordVisibilityToggle}>
                      {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  ),
                }}
                error={!!passwordError}
                helperText={
                  passwordError && (
                    <Typography
                      sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                    >
                      {passwordError}
                    </Typography>
                  )
                }
                variant="outlined"
              />

              <TextField
                label="Confirm Password"
                type={isConfirmPasswordVisible ? "text" : "password"}
                fullWidth
                value={deliveryAgentData?.confirmPassword}
                onChange={handleConfirmPasswordChange}
                InputProps={{
                  endAdornment: (
                    <IconButton onClick={handleConfirmPasswordVisibilityToggle}>
                      {isConfirmPasswordVisible ? (
                        <VisibilityOff />
                      ) : (
                        <Visibility />
                      )}
                    </IconButton>
                  ),
                }}
                error={!!confirmPasswordError}
                helperText={
                  confirmPasswordError && (
                    <Typography
                      sx={{ textAlign: "left", marginTop: 1, color: "red" }}
                    >
                      {confirmPasswordError}
                    </Typography>
                  )
                }
                variant="outlined"
              />
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
              <Button
                onClick={() => setOpen(false)}
                sx={{ marginRight: 2, color: "white", backgroundColor: "red" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSubmit}
                sx={{ color: "white", backgroundColor: "green" }}
              >
                {isEditMode ? "Update" : "Add"}
              </Button>
            </Box>
          </Box>
        </Modal>
        <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
          <DialogTitle>
            {snackbarState.status === true ? "Success" : "Error"}
          </DialogTitle>
          <DialogContent>
            <Typography
              variant="body1"
              sx={{
                color: snackbarState.status === true ? "green" : "red",
              }}
            >
              {snackbarState.message}
            </Typography>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleClose}
              sx={{
                textTransform: "none",
                borderRadius: 2,
                alignSelf: "center",
              }}
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>
        {/* Modal for View Icon */}
        <Modal
          open={openViewModal}
          onClose={handleViewClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)", // Center the modal
              width: "80vw",
              height: "90vh",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 3,
              overflowY: "scroll", // Enable vertical scrolling
              borderRadius: 2, // Rounded corners
              "&::-webkit-scrollbar": {
                display: "none", // Hide scrollbar for Webkit browsers
              },
              "-ms-overflow-style": "none", // Hide scrollbar for Internet Explorer and Edge
              "scrollbar-width": "none", // Hide scrollbar for Firefox
            }}
          >
            <Box sx={{ position: "relative" }}>
              <h2 id="modal-title">
                {deliveryAgentData?.id ? "Edit Delivery" : "View Delivery"}
              </h2>
              <IconButton
                aria-label="close"
                onClick={handleViewClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ width: "100%", padding: 2 }}>
              <Tabs value={tabValue} onChange={handleTabChange} centered>
                <Tab label="Profile" />
                <Tab label="Delivery History" />
              </Tabs>

              <TabPanel value={tabValue} index={0}>
                <Box
                  sx={{
                    // maxWidth: 800,
                    margin: "auto",
                    padding: 4,
                    boxShadow: 1,
                    borderRadius: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  {/* Profile Header */}
                  <Box display="flex" alignItems="center" marginBottom={4}>
                    <Box
                      sx={{
                        width: 64,
                        height: 64,
                        borderRadius: "50%",
                        backgroundColor: "#ddd",
                        marginRight: 2,
                      }}
                    />
                    <Box>
                      <Typography variant="h6" fontWeight="bold">
                        {deliveryAgentViewData?.name}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {deliveryAgentViewData?.email}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Form Fields */}
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Agent ID"
                        value={deliveryAgentViewData?.deliveryAgentId}
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Phone"
                        value={deliveryAgentViewData?.phoneNumber}
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Location"
                        value={deliveryAgentViewData?.location}
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Status"
                        value={deliveryAgentViewData?.status}
                        fullWidth
                        InputProps={{
                          readOnly: true,
                          sx: {
                            color: "green",
                            fontWeight: "bold",
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        label="Aadhar Number"
                        value={deliveryAgentViewData?.aadhar || ""}
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>

                    <Grid item xs={6}>
                      <TextField
                        label="Date of Birth"
                        value={deliveryAgentViewData?.dob || ""}
                        fullWidth
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Grid>

                  <Box marginTop={2}>
                    <Grid item xs={6}>
                      <TextField
                        label="Address"
                        fullWidth
                        multiline
                        value={deliveryAgentViewData?.location}
                        rows={4} // Adjust the number of visible rows
                        InputProps={{ readOnly: true }}
                      />
                    </Grid>
                  </Box>
                </Box>
              </TabPanel>

              <TabPanel value={tabValue} index={1}>
                <Paper elevation={3} sx={{ padding: 2, borderRadius: "20px" }}>
                  {/* Status Filter Dropdown */}
                  <Box
                    sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}
                  >
                    <Select
                      value={deliveryOrderStatus}
                      onChange={(e) => setDeliveryOrderStatus(e.target.value)}
                      variant="outlined"
                      sx={{ width: 200, backgroundColor: "#fff" }}
                    >
                      <MenuItem value="ALL">All</MenuItem>
                      <MenuItem value="ACCEPTED">ACCEPTED</MenuItem>
                      <MenuItem value="PENDING">PENDING</MenuItem>
                      <MenuItem value="PICKED">PICKED</MenuItem>
                      <MenuItem value="DELIVERED">DELIVERED</MenuItem>
                      <MenuItem value="REJECTED">REJECTED</MenuItem>
                      <MenuItem value="COMPLETED">COMPLETED</MenuItem>
                    </Select>
                  </Box>

                  <TableContainer
                    component={Paper}
                    sx={{ borderRadius: "20px" }}
                  >
                    <Table>
                      <TableHead sx={{ backgroundColor: "#F5F5F5" }}>
                        <TableRow>
                          <TableCell>Order ID</TableCell>
                          <TableCell>Customer</TableCell>
                          <TableCell>Vendor</TableCell>
                          <TableCell>Payment</TableCell>
                          <TableCell>Amount</TableCell>
                          <TableCell>Status</TableCell>
                          <TableCell>Date</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {isAgentOrdersLoading ? (
                          <TableRow>
                            <TableCell colSpan={7} align="center">
                              <Typography>Loading...</Typography>
                            </TableCell>
                          </TableRow>
                        ) : deliveryHistory.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={7} align="center">
                              <Typography>
                                No delivery history found.
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ) : (
                          deliveryHistory
                            .slice(
                              deliveryPage * deliveryRowsPerPage,
                              deliveryPage * deliveryRowsPerPage +
                                deliveryRowsPerPage,
                            )
                            .map((order, index) => (
                              <TableRow key={order.agent_assign_id || index}>
                                <TableCell>
                                  {order.cartDetails?.cart_number || "-"}
                                </TableCell>
                                <TableCell>
                                  {order.cartDetails?.customerDetails
                                    ?.first_name || "-"}{" "}
                                  {order.cartDetails?.customerDetails
                                    ?.last_name || ""}
                                </TableCell>
                                <TableCell>
                                  {order.vendorDetails?.shop_name || "-"}
                                </TableCell>
                                <TableCell>
                                  {order.cartDetails?.payment_method === "COD"
                                    ? "Cash on Delivery"
                                    : "Online Payment"}
                                </TableCell>
                                <TableCell>
                                  ₹{order.cartDetails?.cart_total_amount || "0"}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    fontWeight: "bold",
                                    color:
                                      order.order_status === "DELIVERED"
                                        ? "green"
                                        : order.order_status === "PENDING"
                                          ? "orange"
                                          : order.order_status === "CANCELED"
                                            ? "red"
                                            : "black",
                                  }}
                                >
                                  {order.order_status}
                                </TableCell>
                                <TableCell>
                                  {new Date(order.createdAt).toLocaleDateString(
                                    "en-GB",
                                    {
                                      day: "2-digit",
                                      month: "short",
                                      year: "numeric",
                                    },
                                  )}
                                </TableCell>
                              </TableRow>
                            ))
                        )}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, 50]}
                      component="div"
                      count={deliveryHistory.length}
                      rowsPerPage={deliveryRowsPerPage}
                      page={deliveryPage}
                      onPageChange={(event, newPage) =>
                        setDeliveryPage(newPage)
                      }
                      onRowsPerPageChange={(event) => {
                        setDeliveryRowsPerPage(
                          parseInt(event.target.value, 10),
                        );
                        setDeliveryPage(0);
                      }}
                    />
                  </TableContainer>
                </Paper>
              </TabPanel>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleViewClose}
                sx={{ color: "white", backgroundColor: "red" }}
              >
                Close
              </Button>
            </Box>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
};

export default AdminDeliveryManagement;
